/* Where a booked square's clock begins.
 *
 * The book's time, as a rule — a client booked at ten and seated at ten past
 * because somebody was slow to the keyboard is ten minutes into the service,
 * and the countdown should say so. See `bookedOutcome` in the store.
 *
 * Except for the first service of the visit, when the booking system has said
 * when it was started. Kevin, 2026-10-23: Ann DiVizio was booked at four and
 * started in Mangomint at 4:11 because the client was running late. The square
 * went up at 4:12 backdated to four, so the late start the board marks
 * (js/rules/start-offset.js) could never appear. The booking system's start is
 * when the client actually sat down; it is the correct start.
 *
 * "First" is every service booked at the visit's earliest time — two
 * technicians starting together at four both started with the client. Anything
 * booked later in the visit keeps its own booked time: the check-in is the
 * client arriving, not every chair on the booking (js/rules/auto-start.js).
 *
 * Nothing here undoes the mark when the desk moves the booking to match the
 * late arrival. The mark reads the book's time as it is now, so a booking moved
 * to 4:10 puts a 4:11 start inside the margin and the mark goes on its own.
 *
 * Never ahead of the clock, in either case: a square whose timer has not begun
 * counting cannot be read.
 *
 * This file imports nothing, for the same reason as js/rules/conflict.js.
 */

// The earliest booked start on the visit, or null when none has a time.
export function firstBookedStart(services) {
  var first = null;
  (services || []).forEach(function (s) {
    if (!s || s.startsAt == null) return;
    if (first == null || s.startsAt < first) first = s.startsAt;
  });
  return first;
}

/* The start, or null for a line with no booked time (the caller then uses its
 * own). `startedAt` is the booking system's start for the visit, or null. */
export function seatedStart(bookedAt, firstBookedAt, startedAt, now) {
  if (bookedAt == null) return null;
  if (startedAt != null && firstBookedAt != null && bookedAt === firstBookedAt) {
    return Math.min(startedAt, now);
  }
  return Math.min(bookedAt, now);
}
